import type { Ref } from "vue";

type RepeatRefs = {
  intervalTaskId?: Ref<IntervalHandle | null> | null;
  repeatInterval?: Ref<number> | number;
};

export function useRepeatTask({ intervalTaskId, repeatInterval = 10000 }: RepeatRefs) {
  let intervalId: IntervalHandle | null = intervalTaskId?.value ?? null;
  const getInterval = () =>
    typeof repeatInterval === "number" ? repeatInterval : (repeatInterval?.value ?? 10000);

  function startRepeat(repeatTasks: Array<() => void>) {
    stopRepeat();
    intervalId = window.setInterval(() => {
      repeatTasks.forEach((func) => {
        try {
          func();
        } catch (error) {
          console.error(error);
        }
      });
    }, getInterval());
    if (intervalTaskId) {
      intervalTaskId.value = intervalId;
    }
  }

  function stopRepeat() {
    if (intervalId != null) {
      window.clearInterval(intervalId);
    }
    intervalId = null;
    if (intervalTaskId) {
      intervalTaskId.value = null;
    }
  }

  return {
    startRepeat,
    stopRepeat,
  };
}

export default useRepeatTask;
